import {
    OPEN_AGENT_POPUP,
    CLOSE_AGENT_POPUP,
    ADD_MESSAGE,
    SET_MESSAGES,
    CLEAR_MESSAGES,
    UPDATE_MESSAGE,
    ADD_CONVERSATION_PAIR,
    SET_CONVERSATION_PAIRS,
    CLEAR_CONVERSATION_PAIRS,
    SET_WORKSPACE_OPTIONS,
    SET_WORKSPACE_OPTIONS_LOADING,
    SET_WORKSPACE_OPTIONS_LOADED,
    SET_CHAT_STEP,
    SET_SELECTED_LOCATIONS,
    SET_FIRST_RECOMMENDATION_DISPLAYED,
    SET_INITIAL_MESSAGE_SET,
    SET_HAS_AUTO_FETCHED,
    SET_LOADING,
    SET_INITIAL_LOADING,
    SET_CONTACT_FORM,
    SET_SHOW_CONTACT_FORM,
    RESET_CHAT_SESSION,
    CLEAR_CHAT_SESSION,
    SET_SPACE_IDS,
    SET_EVENT_IDS,
    ADD_SPACE_ID,
    ADD_EVENT_ID,
    FETCH_USER_DATA_REQUEST,
    FETCH_USER_DATA_SUCCESS,
    FETCH_USER_DATA_FAILURE,
    CLEAR_USER_DATA,
    UPDATE_USER_DATA
} from './agentActionTypes';

import { fetchUserDataAndBookings } from '../../components/Agent/utils/chatbotApiUtils';

export const openAgentPopup = () => ({
    type: OPEN_AGENT_POPUP,
});

export const closeAgentPopup = () => ({
    type: CLOSE_AGENT_POPUP,
});

// Chat state management actions
export const addMessage = (message) => ({
    type: ADD_MESSAGE,
    payload: message,
});

export const setMessages = (messages) => ({
    type: SET_MESSAGES,
    payload: messages,
});

export const clearMessages = () => ({
    type: CLEAR_MESSAGES,
});

export const updateMessage = (messageId, updates) => ({
    type: UPDATE_MESSAGE,
    payload: { messageId, updates },
});

// Conversation pairs management actions
export const addConversationPair = (pair) => ({
    type: ADD_CONVERSATION_PAIR,
    payload: pair,
});

export const setConversationPairs = (pairs) => ({
    type: SET_CONVERSATION_PAIRS,
    payload: pairs,
});

export const clearConversationPairs = () => ({
    type: CLEAR_CONVERSATION_PAIRS,
});

// Workspace options management actions
export const setWorkspaceOptions = (options) => ({
    type: SET_WORKSPACE_OPTIONS,
    payload: options,
});

export const setWorkspaceOptionsLoading = (loading) => ({
    type: SET_WORKSPACE_OPTIONS_LOADING,
    payload: loading,
});

export const setWorkspaceOptionsLoaded = (loaded) => ({
    type: SET_WORKSPACE_OPTIONS_LOADED,
    payload: loaded,
});

// Session management actions
export const setChatStep = (step) => ({
    type: SET_CHAT_STEP,
    payload: step,
});

export const setSelectedLocations = (locations) => ({
    type: SET_SELECTED_LOCATIONS,
    payload: locations,
});

export const setFirstRecommendationDisplayed = (displayed) => ({
    type: SET_FIRST_RECOMMENDATION_DISPLAYED,
    payload: displayed,
});

export const setInitialMessageSet = (set) => ({
    type: SET_INITIAL_MESSAGE_SET,
    payload: set,
});

export const setHasAutoFetched = (fetched) => ({
    type: SET_HAS_AUTO_FETCHED,
    payload: fetched,
});

// Loading states actions
export const setLoading = (loading) => ({
    type: SET_LOADING,
    payload: loading,
});

export const setInitialLoading = (loading) => ({
    type: SET_INITIAL_LOADING,
    payload: loading,
});

// Contact form management actions
export const setContactForm = (formData) => ({
    type: SET_CONTACT_FORM,
    payload: formData,
});

export const setShowContactForm = (show) => ({
    type: SET_SHOW_CONTACT_FORM,
    payload: show,
});

// Chat session management actions
export const resetChatSession = () => ({
    type: RESET_CHAT_SESSION,
});

export const clearChatSession = () => ({
    type: CLEAR_CHAT_SESSION,
});

// Space and event IDs management actions
export const setSpaceIds = (spaceIds) => ({
    type: SET_SPACE_IDS,
    payload: spaceIds,
});

export const setEventIds = (eventIds) => ({
    type: SET_EVENT_IDS,
    payload: eventIds,
});

export const addSpaceId = (spaceId) => ({
    type: ADD_SPACE_ID,
    payload: spaceId,
});

export const addEventId = (eventId) => ({
    type: ADD_EVENT_ID,
    payload: eventId,
});

// User data management actions
export const fetchUserDataRequest = () => ({
    type: FETCH_USER_DATA_REQUEST,
});

export const fetchUserDataSuccess = (userData) => ({
    type: FETCH_USER_DATA_SUCCESS,
    payload: userData,
});

export const fetchUserDataFailure = (error) => ({
    type: FETCH_USER_DATA_FAILURE,
    payload: error,
});

export const clearUserData = () => ({
    type: CLEAR_USER_DATA,
});

export const updateUserData = (updates) => ({
    type: UPDATE_USER_DATA,
    payload: updates,
});

// Thunk actions for complex operations
export const initializeChatSession = () => (dispatch) => {
    dispatch(setChatStep(1));
    dispatch(setSelectedLocations([]));
    dispatch(setFirstRecommendationDisplayed(false));
    dispatch(setInitialMessageSet(false));
    dispatch(setHasAutoFetched(false));
    dispatch(setLoading(false));
    dispatch(setInitialLoading(false));
    dispatch(setShowContactForm(false));
    dispatch(setContactForm({
        name: '',
        email: '',
        phoneNumber: '',
        message: ''
    }));
};

export const resetChatToInitialState = () => (dispatch) => {
    dispatch(clearMessages());
    dispatch(clearConversationPairs());
    dispatch(setSpaceIds([]));
    dispatch(setEventIds([]));
    dispatch(initializeChatSession());
};

export const fetchUserData = () => (dispatch) => {
    dispatch(fetchUserDataRequest());
    fetchUserDataAndBookings()
        .then(userData => {
            console.log('Chatbot: fetchUserData action received data:', userData);
            dispatch(fetchUserDataSuccess(userData));
        })
        .catch(error => {
            console.error('Chatbot: fetchUserData action error:', error);
            dispatch(fetchUserDataFailure(error));
        });
}; 